import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './pwa-styles.css'; // PWA-specific styles for fullscreen and viewport fixes
import App from './App';
import reportWebVitals from './reportWebVitals';

// -------------------- DQGMS MOCKUP MODE --------------------
// When REACT_APP_USE_MOCK === 'true', boot MSW before rendering.
// In every other build (real prod, dev against real backend), this
// block is a no-op and MSW is not imported. See DQGMS_MOCKUP_CHANGELOG.md.
async function enableMocking() {
  if (process.env.REACT_APP_USE_MOCK !== 'true') return;
  const { worker } = await import('./mocks/browser');
  return worker.start({ onUnhandledRequest: 'warn' });
}
// -----------------------------------------------------------

enableMocking().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
